import axios from 'axios';
import Cookies from 'js-cookie';
export const TOKEN_REFRESH_TIMEOUT = 600000; // (10 minutes)
export const API_BASE_URL = process.env.API_BASE_URL || ''; // no trailing slash

const tokenKeyName = 'token';

export function setupAxios(){
  axios.defaults.withCredentials = false;
  axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    const token = Cookies.get(tokenKeyName);
    if (token) {
      const headers = {
        Authorization: ` JWT ${token}`
      };

      config.headers = { ...config.headers, ...headers }
    }
    
    authRefreshToken();

    if (config.url.startsWith('/')){
      config.url = `${API_BASE_URL}${config.url}`;
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
}

export function authRefreshToken() {
  const cookieExpiration = Cookies.get('token_init');
  if (!cookieExpiration) {
    Cookies.set('token_init', new Date().toISOString(), { expires: 1 });
    return;
  }
  const now = Date.now();

  // If expiration time - now is lower than 1 hour, refresh the token
  if ((new Date(cookieExpiration).getTime() - now) >= TOKEN_REFRESH_TIMEOUT) {
    axios.post('/api-token-refresh/', {
      token: Cookies.get(tokenKeyName)
    }).then(({ data }) => {
      Cookies.set(tokenKeyName, data.token);
    });
  }
}